import React from "react";
import styles from "./bulk_discount_bar.module.css";
import classNames from "classnames";

interface BulkDiscountBarProps {
  title: string;
  description: string;
}

export function BulkDiscountBar({ title, description }: BulkDiscountBarProps) {
  return (
    <div
      className={classNames(styles.background, "offering-bulk-discount-bar")}
    >
      <div className={styles.title}>{title}</div>
      <div>{description}</div>
    </div>
  );
}
